import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import thunk from 'redux-thunk'
import reducers from '../reducers'

const composeEnhancers = /*compose*/  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

export const initialState = {
  data: {
    config:{
      api_token: typeof avant !== 'undefined' && avant.api_token,
      client_install: typeof avant !== 'undefined' && avant.client_install_uuid,
      client_version: 'b3859a1b-0255-4e18-ae2f-cc5d58e0d956',
      locale: ((typeof avant !== 'undefined' && avant.locale) || `en-US`)
    },
    customer_applications: [],
    loans: [],
    credit_card_accounts: [],
    notices: [],
    workflow_notices: [],
    actionable_payments: [],
    customer: { ...(typeof avant !== 'undefined' ? avant.customer : {}) },
    loading: 0
  }
}

export default function configureStore() {
  return createStore(reducers, initialState, composeEnhancers(applyMiddleware(thunk)))
}
